import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import DesignANewQuest from '../components/mini/DesignANewQuest'
import UserAvatar from '../components/mini/UserAvatar'
import MyQuestsComponent from '../components/myquests/MyQuests'
import UserStats from '../components/myquests/UserStats'
import HeaderLockup from '../components/mini/HeaderLockup'

import { getUserData } from '../actions/user'
import {
  setMyQuestsFilter,
  setMyQuestsSort,
  fetchMyQuests
} from '../actions/myquests'
import {
  setAuthorFilter,
  setKeywordFilter,
  setDraftFilter,
  setStatusFilter,
  setAssignedToFilter
} from '../actions/myquestsfilters'
import { currentOrg } from '../selectors/organization'

class MyQuests extends Component {
  constructor(props) {
    super(props)
    this.addQuestBound = this.addQuest.bind(this)
    this.onAssignedToMeClickBound = this.onAssignedToMeClick.bind(this)
    this.onDraftsClickBound = this.onDraftsClick.bind(this)
    this.onInQualityReviewClickBound = this.onInQualityReviewClick.bind(this)
    this.onPublishedClickBound = this.onPublishedClick.bind(this)
    this.onSortClickBound = this.onSortClick.bind(this)
    this.fetchQuestsBound = this.fetchQuests.bind(this)
    this.onSearchChangeBound = this.onSearchChange.bind(this)
    this.onSearchClickBound = this.onSearchClick.bind(this)
    this.onClearTitleFilterClickBound = this.onClearTitleFilterClick.bind(this)
    this.onKeyPressBound = this.onKeyPress.bind(this)
  }

  componentDidMount() {
    this.props.dispatch(getUserData())
    this.fetchQuests(1, true)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.orgId !== this.props.orgId) {
      this.fetchQuests(1, true)
    }
  }

  render() {
    const {
      user,
      filter,
      isLoadingUserData,
      sort,
      isLoadingQuests,
      dispatch,
      quests,
      keywordFilter,
      page,
      total,
      organization
    } = this.props

    return (
      <div className="myquests-container">
        <Fragment>
          <HeaderLockup
            avatarComponent={<UserAvatar photoUrl={user.user.photo.url} />}
            organization={organization}
            section="My Quests"
          />
          <DesignANewQuest addQuest={this.addQuestBound} />
        </Fragment>
        {!isLoadingUserData && (
          <Fragment>
            <div className="myquests-left">
              <UserStats stats={user.stats} />
            </div>

            <div className="myquests-main">
              <MyQuestsComponent
                quests={quests}
                stats={user.stats}
                filter={filter}
                sort={sort}
                isLoading={isLoadingQuests}
                handleSortClick={this.onSortClickBound}
                handleAssignmentsClick={this.onAssignedToMeClickBound}
                handleDraftsClick={this.onDraftsClickBound}
                handleInQualityReviewClick={this.onInQualityReviewClickBound}
                handlePublishedClick={this.onPublishedClickBound}
                fetchQuests={this.fetchQuestsBound}
                dispatch={dispatch}
                user={user.user}
                handleSearchChange={this.onSearchChangeBound}
                handleSearchClick={this.onSearchClickBound}
                keywordFilter={keywordFilter}
                clearTitleFilter={this.onClearTitleFilterClickBound}
                handleKeyPress={this.onKeyPressBound}
                page={page}
                total={total}
                addQuest={this.addQuestBound}
              />
            </div>
          </Fragment>
        )}
        {isLoadingUserData && <div className="loading" />}
      </div>
    )
  }

  addQuest() {
    this.props.dispatch(push('/quests/add'))
  }

  async onAssignedToMeClick() {
    const { dispatch, user } = this.props
    await dispatch(setMyQuestsFilter('assignments'))
    await dispatch(setDraftFilter([]))
    await dispatch(setStatusFilter([]))
    await dispatch(setAuthorFilter([]))
    await dispatch(setAssignedToFilter([user.user.id]))
    await dispatch(setKeywordFilter(''))
    this.fetchQuests(1, true)
  }

  async onDraftsClick() {
    const { dispatch, user } = this.props
    await dispatch(setMyQuestsFilter('drafts'))
    await dispatch(setDraftFilter([2]))
    await dispatch(setStatusFilter([]))
    await dispatch(setAuthorFilter([user.user.id]))
    await dispatch(setAssignedToFilter([]))
    await dispatch(setKeywordFilter(''))
    this.fetchQuests(1, true)
  }

  async onInQualityReviewClick() {
    const { dispatch, user } = this.props
    await dispatch(setMyQuestsFilter('inQualityReview'))
    await dispatch(setDraftFilter([]))
    await dispatch(setStatusFilter([0, 4]))
    await dispatch(setAuthorFilter([user.user.id]))
    await dispatch(setAssignedToFilter([]))
    await dispatch(setKeywordFilter(''))
    this.fetchQuests(1, true)
  }

  async onPublishedClick() {
    const { dispatch, user } = this.props
    await dispatch(setMyQuestsFilter('published'))
    await dispatch(setDraftFilter([]))
    await dispatch(setStatusFilter([5]))
    await dispatch(setAuthorFilter([user.user.id]))
    await dispatch(setAssignedToFilter([]))
    this.fetchQuests(1, true)
  }

  async onSortClick(e) {
    await this.props.dispatch(setMyQuestsSort(e.currentTarget.dataset.ref))
    this.fetchQuests(1, true)
  }

  fetchQuests(page, clearQuests) {
    this.props.dispatch(fetchMyQuests(page, clearQuests))
  }

  onSearchChange(event) {
    this.props.dispatch(setKeywordFilter(event.target.value))
  }

  async onSearchClick(keywordFilter) {
    await this.props.dispatch(setKeywordFilter(keywordFilter))
    this.fetchQuests(1, true)
  }

  async onClearTitleFilterClick() {
    await this.props.dispatch(setKeywordFilter(''))
    document.getElementById('myQuestsTitleFilter').value = ''
    this.fetchQuests(1, true)
  }

  onKeyPress(e, keywordFilter) {
    if (e.which === 13 || e.charCode === 13) {
      this.onSearchClick(keywordFilter)
    }
  }
}

MyQuests.propTypes = {
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  isLoadingQuests: PropTypes.bool.isRequired,
  filter: PropTypes.string.isRequired,
  isLoadingUserData: PropTypes.bool.isRequired,
  sort: PropTypes.string.isRequired,
  quests: PropTypes.array,
  keywordFilter: PropTypes.string,
  page: PropTypes.number,
  total: PropTypes.number,
  orgId: PropTypes.number,
  organization: PropTypes.object
}

export const mapStateToProps = state => ({
  user: state.user,
  isLoadingQuests: state.myquests.isFetchingQuests,
  filter: state.myquests.filter,
  isLoadingUserData: state.user.isLoading,
  sort: state.myquests.sort,
  quests: state.myquests.quests,
  keywordFilter: state.myquestsfilters.name_or_description_cont,
  page: state.myquests.page,
  total: state.myquests.total,
  orgId: state.organization.orgId,
  organization: currentOrg(state)
})

export default connect(mapStateToProps)(MyQuests)
export { MyQuests as MyQuestsDisconnected }



// WEBPACK FOOTER //
// ./src/containers/MyQuests.js